import { IBranchDetail, IBranchFormPersistence, IBranchFormValues } from '../interfaces';

const DEFAULT_STATE_ID = '85';

export class BranchFormMapper {
  public static toDomain(branch: IBranchDetail): IBranchFormValues {
    return {
      id: branch.id.toString(),
      name: branch.name,
      descr: branch.descr,
      parentId: branch.parent?.id ? branch.parent.id.toString() : '',
      address: branch.address,
      isBranch: branch.isBranch,
      mapAddress: branch.mapAddress,
      email: branch.email,
      workinghours: branch.workinghours,
      phone: branch.phone,
      companyId: branch.company?.id ? branch.company.id.toString() : '',
      hide: branch.hide,
      isRegionBranch: branch.isRegionBranch,
      latitude: branch.latitude,
      longitude: branch.longitude,
      mapUrl: branch.mapUrl,
      sortingLetter: branch.sortingLetter,
      stateId: branch.status?.id ? branch.status.id.toString() : DEFAULT_STATE_ID,
      cityName: branch.cityName,
      openHour: branch.openHour,
      closeHour: branch.closeHour,
      openHourSaturday: branch.openHourSaturday,
      closeHourSaturday: branch.closeHourSaturday,
      postCode: branch.postCode,
      provinceName: branch.provinceName,
      warehouseMan: branch.warehouseMan,
    };
  }

  public static toPersistence(branch: IBranchFormValues, id?: string | number): IBranchFormPersistence {
    return {
      branch_id: id ? String(id) : branch.id,
      descr: branch.descr,
      name: branch.name,
      is_branch: branch.isBranch ? '1' : '0',
      parent_id: branch.parentId,
      address: branch.address,
      workinghours: branch.workinghours,
      email: branch.email,
      map_address: branch.mapAddress,
      phone: branch.phone,
      company_id: branch.companyId,
      hide: branch.hide ? '1' : '0',
      is_region_branch: branch.isRegionBranch ? '1' : '0',
      latitude: branch.latitude,
      longitude: branch.longitude,
      map_url: branch.mapUrl,
      sorting_letter: branch.sortingLetter,
      state_id: branch.stateId,
      open_hour: branch.openHour,
      close_hour: branch.closeHour,
      open_hour_saturday: branch.openHourSaturday,
      close_hour_saturday: branch.closeHourSaturday,
      city_name: branch.cityName,
      post_code: branch.postCode,
      province_name: branch.provinceName,
      warehouseman: branch.warehouseMan,
    };
  }
}

export class BranchFormErrorsMapper {
  public static toDomain(errors: Record<string, string[]>): Partial<Record<keyof IBranchFormValues, string>> {
    return {
      id: errors.id?.join('. '),
      name: errors.name?.join('. '),
      address: errors.address?.join('. '),
      descr: errors.descr?.join('. '),
      email: errors.email?.join('. '),
      parentId: errors.parent_id?.join('. '),
      isBranch: errors.is_branch?.join('. '),
      mapAddress: errors.map_address?.join('. '),
      mapUrl: errors.map_url?.join('. '),
      phone: errors.phone?.join('. '),
      workinghours: errors.workinghours?.join('. '),
      companyId: errors.company_id?.join('. '),
      hide: errors.hide?.join('. '),
      isRegionBranch: errors.is_region_branch?.join('. '),
      latitude: errors.latitude?.join('. '),
      longitude: errors.longitude?.join('. '),
      sortingLetter: errors.sorting_letter?.join('. '),
      stateId: errors.state_id?.join('. '),
      cityName: errors.city_name?.join('. '),
      openHour: errors.open_hour?.join('. '),
      openHourSaturday: errors.open_hour_saturday?.join('. '),
      closeHour: errors.close_hour?.join('. '),
      closeHourSaturday: errors.close_hour_saturday?.join('. '),
      provinceName: errors.province_name?.join('. '),
      postCode: errors.post_code?.join('. '),
      warehouseMan: errors.warehouseman?.join('. '),
    };
  }
}
